/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Offers\AttribuedCar\AttribuedCarRow\AttribuedCarRow.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Wednesday October 16th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday October 16th 2024 10:13:15 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { Button, TableCell, TextField } from "@mui/material";
import { useRef, useState } from "react";
import { AttribuedCarType } from "Type/AttribuedCar.type";
import Styles from "Content/Offers/AttribuedCar/AttribuedCarRow/AttribuedCarRow.module.css";
import dayjs, { Dayjs } from "dayjs";
import { IoIosSave } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import OfferFiles from "Content/Offers/OfferFiles/OfferFiles";
import AttribuedCarService from "Services/AttribuedCar/AttribuedCarService";
import OfferFileService from "Services/Offer/OfferFileService";
import DateBtnForm from "Content/DateBtnForm/DateBtnForm";
import CollapsRow from "Content/Offers/CollapsRow/CollapsRow";
import { ModalConfirmRequest } from "Content/Modals/ModalConfirmRequest/ModalConfirmRequest";
import translator from "MultiLanguage/TranslationWrapper";

type AttribuedCarRow = {
    data: AttribuedCarType,
    handleDelete: Function,
    setterFileCountGlobal: Function
}

export default function AttribuedCarRow(props: AttribuedCarRow) {
    const [regNb, setRegNb] = useState(props.data.RegNb ?? "");
    const [VIN, setVIN] = useState(props.data.VIN ?? "");
    const [orderNb, setOrderNb] = useState(props.data.OrderNb ?? "");
    const [MEC, setMEC] = useState<Dayjs | null>(props.data.MEC ? dayjs(props.data.MEC) : null);
    const [dateDelivery, setDateDelivery] = useState<Dayjs | null>(props.data.DateDelivery ? dayjs(props.data.DateDelivery) : null);
    const [dateReport, setDateReport] = useState<Dayjs | null>(props.data.DateReport ? dayjs(props.data.DateReport) : null);
    const [dateEndContract, setDateEndContract] = useState<Dayjs | null>(props.data.DateEndContract ? dayjs(props.data.DateEndContract) : null);
    const [endMileage, setEndMileage] = useState(props.data.EndMileage);
    const [nbFile, setNbFile] = useState(props.data._count.OfferFile);
    const [open, setOpen] = useState(false);
    const originalState: {[k: string]: Dayjs | number | string | null} = {
        VIN: props.data.VIN ?? "",
        RegNb: props.data.RegNb ?? "",
        OrderNb: props.data.OrderNb ?? "",
        MEC: props.data.MEC ? dayjs(props.data.MEC) : null,
        DateDelivery: props.data.DateDelivery ? dayjs(props.data.DateDelivery) : null,
        DateReport: props.data.DateReport ? dayjs(props.data.DateReport) : null,
        DateEndContract: props.data.DateEndContract ? dayjs(props.data.DateEndContract) : null,
        EndMileage: props.data.EndMileage ?? 0
    };
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [isSendable, setIsSendable] = useState(false);
    const updateObject = useRef<{[k: string]: Dayjs | number | string}>({});

    const HandleCloseModal = () => {
        setOpenModal(false);
    };

    const checkIsSendable = () => {
        const keys = Object.keys(updateObject.current);
        for (let k of keys) {
            if (k in originalState) {
                if (updateObject.current[k] == originalState[k])
                    delete updateObject.current[k];
            } else {
                delete updateObject.current[k];
                checkIsSendable();
            }
        }
        setIsSendable(Object.keys(updateObject.current).length > 0);
    };

    const HandleFileCountChange = (nb: number, isDelete: boolean = false) => {
        if (!isDelete)
            setNbFile(nbFile + nb);
        else
            setNbFile(nbFile - nb);
        props.setterFileCountGlobal(nb, isDelete);
    };

    const handleAddFile = (upload: FileList) => {
        return OfferFileService.addFile(props.data.OfferID, upload, props.data.id);
    };
    const handleGetFile = () => {
        return AttribuedCarService.getAttribuedCarFiles(props.data.id);
    };

    const handleSave = () => {
        AttribuedCarService.update(props.data.id, updateObject.current).then((result) => {
            console.log(result);
        }).catch((error) => {
            console.error(error);
        });
    };

    const updateValue = (val: string | dayjs.Dayjs | number | null, setter: Function, key: string) => {
        if (["RegNb", "VIN", "OrderNb", "EndMileage"].includes(key))
            setter(val);
        else if (["MEC", "dateDelivery", "dateReport", "dateEndContract"].includes(key))
            setter((val as Dayjs).set("second", 0).set("millisecond", 0));

        if (val)
            updateObject.current[key] = val;
        else
            delete updateObject.current[key];
        checkIsSendable();
    };

    return (
        <>
            <CollapsRow collapseChildren={<OfferFiles offerID={props.data.OfferID} changeFileCount={HandleFileCountChange} getter={handleGetFile} saving={handleAddFile} />}>
                <TableCell align="center" onClick={() => setOpen(!open)}>
                    {nbFile}
                </TableCell>
                <TableCell align="center" className={`${Styles.inputText}`}>
                    <TextField size="small" value={regNb} onChange={(e) => updateValue(e.target.value, setRegNb, "RegNb")} />
                </TableCell>
                <TableCell align="center" className={`${Styles.inputText}`}>
                    <TextField size="small" value={VIN} onChange={(e) => updateValue(e.target.value, setVIN, "VIN")} />
                </TableCell>
                <TableCell align="center" className={`${Styles.inputText}`}>
                    <TextField size="small" value={orderNb} onChange={(e) => updateValue(e.target.value, setOrderNb, "OrderNb")} />
                </TableCell>
                <TableCell align="center">
                    <DateBtnForm updateKey={"MEC"} date={MEC} setter={setMEC} updateValue={updateValue} />
                </TableCell>
                <TableCell align="center">
                    <DateBtnForm updateKey={"DateDelivery"} date={dateDelivery} setter={setDateDelivery} updateValue={updateValue} />
                </TableCell>
                <TableCell align="center">
                    <DateBtnForm updateKey={"DateReport"} date={dateReport} setter={setDateReport} updateValue={updateValue} />
                </TableCell>
                <TableCell align="center">
                    <DateBtnForm updateKey={"DateEndContract"} date={dateEndContract} setter={setDateEndContract} updateValue={updateValue} />
                </TableCell>
                <TableCell align="center">
                    <input className={`${Styles.inputNumber}`} type="number" value={endMileage ?? 0} min={1} onChange={(e) => updateValue(e.target.value, setEndMileage, "EndMileage")} />
                </TableCell>
                <TableCell align="center">
                    <div className={`${Styles.action}`}>
                        <Button disabled={!isSendable} onClick={handleSave}>
                            <IoIosSave size={"1.5rem"} />
                        </Button>
                        <Button onClick={() => setOpenModal(true)}>
                            <MdDelete color="red" size={"1.5rem"} />
                        </Button>
                    </div>
                </TableCell>
                <ModalConfirmRequest show={openModal} onClose={HandleCloseModal} closeModal={HandleCloseModal} request={() => props.handleDelete(props.data.id)} title={translator.decode("dynamic.confirm")} />
            </CollapsRow>
        </>
    );
};
